import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as ChatConstants from "../constants/chat.constant";
import ChatService from "../services/chat.service";
import ErrorHelper from "../utils/helpers/errorHelper";

export const fetchUserPrivateChats =
  (receiverId, matricNumber) => async (dispatch) => {
    try {
      dispatch(actionType(ChatConstants.FETCH_PRIVATE_MESSAGE_REQUEST));
      const data = await ChatService.fetchUserPrivateChats(receiverId);
      if (data === undefined || data.status !== 200) {
        throw data;
      }
      dispatch(
        actionType(ChatConstants.FETCH_PRIVATE_MESSAGE_SUCCESS, {
          data: data.data,
          matricNumber: matricNumber,
        })
      );
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(ChatConstants.FETCH_PRIVATE_MESSAGE_ERROR));
      toast.error(message);
    }
  };

export const fetchUserFriends = () => async (dispatch) => {
  try {
    dispatch(actionType(ChatConstants.FETCH_USER_FRIENDS_REQUEST));
    const response = await ChatService.fetchUserFriends();
    console.log("response ==> ", response);
    if (response === undefined || response.status !== 200) {
      throw response;
    }
    dispatch(
      actionType(ChatConstants.FETCH_USER_FRIENDS_SUCCESS, {
        data: response.data,
      })
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ChatConstants.FETCH_USER_FRIENDS_ERROR));
    toast.error(message);
  }
};

export const fetchChatStudentsInfo = (name) => async (dispatch) => {
  try {
    dispatch(actionType(ChatConstants.FETCH_STUDENTS_BY_MATRIC_REQUEST));
    const data = await ChatService.fetchStudentInfo(name);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(
      actionType(ChatConstants.FETCH_STUDENTS_BY_MATRIC_SUCCESS, userData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ChatConstants.FETCH_STUDENTS_BY_MATRIC_ERROR));
    toast.error(message);
  }
};

export const addChatUser = (id) => async (dispatch) => {
  try {
    dispatch(actionType(ChatConstants.ADD_USER_FRIEND_REQUEST));
    const data = await ChatService.addUserFriend(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    toast.success(userData.fullName + " added  to friends list successfully");
    dispatch(actionType(ChatConstants.ADD_USER_FRIEND_SUCCESS, userData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ChatConstants.ADD_USER_FRIEND_ERROR));
    toast.error(message);
  }
};

export const getMessageCount = (receiverId) => async (dispatch) => {
  try {
    dispatch(actionType(ChatConstants.MESSAGE_COUNT_REQUEST));
    const data = await ChatService.fetchUserPrivateCount(receiverId);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(actionType(ChatConstants.MESSAGE_COUNT_SUCCESS, userData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ChatConstants.MESSAGE_COUNT_ERROR));
    toast.error(message);
  }
};

export const findChatMessage = (id) => async (dispatch) => {
  try {
    console.log("id  ===> FETCH_MESSAGE_REQUEST", id);
    dispatch(actionType(ChatConstants.FETCH_MESSAGE_REQUEST));
    const data = await ChatService.fetchMessage(id);
    console.log("data  ===> ", data);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const response = data.data;
    dispatch(actionType(ChatConstants.FETCH_MESSAGE_SUCCESS, response));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(ChatConstants.FETCH_MESSAGE_ERROR));
    toast.error(message);
  }
};

export const setActiveTab = (data) => async (dispatch) => {
  dispatch(actionType(ChatConstants.UPDATE_ACTIVE_TAB, data));
};
